import { useParams } from "react-router-dom";

import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";

import ImgUrl from 'assets/images/channel.png';
import ImgCall from 'assets/images/call.png';
import ImgOnline from 'assets/images/online.png';
import ImgB2B from 'assets/images/b2b.png';
import ImgHomeShop from 'assets/images/homeshop.png';
import ImgOverSea from 'assets/images/oversea.png';

import {pageMenuTabList05} from 'types/common';

import 'assets/css/business.scss';

function Channel() {
  const { brandId } = useParams<{ brandId: string }>();
  
  pageMenuTabList05[1].on = true;
  
  return (
    <div className="page_content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/channel-hero_1920x1080.jpg.jpg" imgText="채널 소개" textcolor="#FFF"></TopImage>
      <PageTab props={pageMenuTabList05}></PageTab>
          
      <div className="business container">

        <div className="container-title">
          천호엔케어는 온라인몰과 전화상담센터,특판, 해외 수출 등<br/>
          국내외 온·오프라인에 걸쳐 다양한 채널을 보유하고 있습니다.
        </div>

        <div className="container-item">
          <div className="container-item-title">전화상담센터</div>
          <div className="container-item-desc">
            천호엔케어 전화상담센터는 1:1로 매칭되는 전담 헬스매니저를 통해<br/>
            고객별 맞춤형 정보를 제공 및 지속적인 건강관리를 돕고 있습니다.
          </div>
          <div className="container-item-img">
            <img src="https://img.chunhomall.com/images/brand_site/channel-section-01_1240x400.jpg.jpg" alt="call" />
          </div>
        </div>

        <div className="container-item">
          <div className="container-item-title">온라인몰</div>
          <div className="container-item-desc">
            천호엔케어에서 직접 운영하는 ‘천호몰’과 ‘네이버 브랜드스토어’를 비롯해<br/>
            종합몰, 오픈마켓에 입점되어 다양한 온라인 채널에서 천호엔케어를 만날 수 있습니다.
          </div>
          <div className="container-item-img">
            <img src={ImgOnline} alt="Online" />
          </div>
        </div>

        <div className="container-item">
          <div className="container-item-title">B2B 특판</div>
          <div className="container-item-desc">
            어린이집/유치원, 초·중·고등학교, 군부대 등 단체에 건강음료를 납품하며 기업 및 관공서에 명절용, 행사용 대량 선물을<br/>
            기획/판매하고 있습니다. 또한 트레이더스 등 오프라인 매장에서도 천호엔케어 제품을 만나볼 수 있습니다.
          </div>
          <div className="container-item-img">
            <div className='container-img-grid type31'>
              <div className="img-style">
                <div className="img-inner">
                  <img src={`https://img.chunhomall.com/images/brand_site/channel-section-10_400x400.jpg.jpg`} alt="Research Image" />
                  <div className="img-inner-text up">
                    급식
                  </div>
                </div>
              </div>

              <div className="img-style">
                <div className="img-inner">
                  <img src={`https://img.chunhomall.com/images/brand_site/channel-section-11_400x400.jpg.jpg`} alt="Research Image" />
                  <div className="img-inner-text up">
                    대량선물
                  </div>
                </div>
              </div>

              <div className="img-style">
                <div className="img-inner">
                  <img src={`https://img.chunhomall.com/images/brand_site/channel-section-12_400x400.jpg.jpg`} alt="Research Image" />
                  <div className="img-inner-text up">
                    대형마트
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>

        <div className="container-item">
          <div className="container-item-title">홈쇼핑</div>
          <div className="container-item-desc">
            TV홈쇼핑, T커머스, 라이브 커머스를 통해 천호엔케어 제품을 보다 생생하게,<br/>
            실시간으로 소통하며 만나볼 수 있습니다.
          </div>
          <div className="container-item-img">
            <div className='container-img-grid col2 type31'>
              <div className="img-style">
                <div className="img-inner">
                  <img src={`https://img.chunhomall.com/images/brand_site/channel-section-13_600x400.jpg.jpg`} alt="Research Image" />
                  <div className="img-inner-text up">
                    TV홈쇼핑
                  </div>
                </div>
              </div>

              <div className="img-style">
                <div className="img-inner">
                  <img src={`https://img.chunhomall.com/images/brand_site/channel-section-14_600x400.jpg.jpg`} alt="Research Image" />
                  <div className="img-inner-text up">
                    T커머스, 라이브 커머스
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-item">
          <div className="container-item-title">해외</div>
          <div className="container-item-desc">
            전세계 16개 나라에 진출해 현지 시장 내 입지를 확대하고 있습니다.
          </div>
          <div className="container-item-img">
            <div className='container-img-grid col1 type31'>
              <div className="img-style">
                <div className="img-inner img-crop-side">
                  <img className="img-oversea" src={`https://img.chunhomall.com/images/brand_site/channel-section-15_1240x400.jpg.jpg`} alt="orversea" />
                  <div className="img-inner-text up">
                    16개국 진출
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Channel;
